import {TagEmp, TagProcess, TagType} from "@FRAMEWORK/ui/mobile/flag";
import {GlobalGoodsFlag} from "@QUERIES/bff/global/useGlobalGoodsFlag";
import {Response} from "@QUERIES/types";
import {useQueryClient} from "@tanstack/react-query";
import {Flag} from "@yb/ui/mobile/common/Flag";
import {emphasisCdLabel, evProgDiviLabel, goodsBrandCdLabel, goodsFlag, goodsTpLabel, TypeFlag} from "../goodsUtil";

/** 상품코드 */
const FlagGoodsCd = (props: {goodsCd: string}) => {
	const {goodsCd} = props;
	return <>{goodsCd && <Flag $type="code" text={goodsCd} />}</>;
};

/* 상품종류 */
const FlagGoodsTp = (props: {goodsTp: string}) => {
	const {goodsTp} = props;
	if (!goodsTp) return <></>;

	const flag = goodsTpLabel(goodsTp);
	return <>{flag && <Flag $type="product" $flag={flag[0]} text={flag[1]} />}</>;
};

/* 브랜드 */
const FlagGoodsBrandCd = (props: {goodsBrandCd: string}) => {
	const {goodsBrandCd} = props;
	if (!goodsBrandCd) return <></>;

	const flag = goodsBrandCdLabel(goodsBrandCd);
	return <>{flag && <Flag $type="brand" $flag={flag[0]} text={flag[1]} />}</>;
};

/* 강조 */
const FlagEmpasisCd = (props: {emphasisCd: string}) => {
	const {emphasisCd} = props;
	if (!emphasisCd) return <></>;

	const flag = emphasisCdLabel(emphasisCd);
	return <>{flag && <TagEmp>{String(flag)}</TagEmp>}</>;
};

/* 여행구성원 */
const FlagGoodsTmember = (props: {goodsTmember: string}) => {
	const {goodsTmember} = props;
	if (!goodsTmember) return <></>;

	const flag = goodsTmember.split(",")[1];
	return <>{flag && <TagType>{flag}</TagType>}</>;
};

/* 진행상태 */
const FlagEvProgDivi = (props: {evProgDivi: string; evProgDiviNm: string}) => {
	const {evProgDivi, evProgDiviNm} = props;
	if (!evProgDivi || !evProgDiviNm) return <></>;

	const flag = evProgDiviLabel(`key${evProgDivi}`);
	return <>{flag && <TagProcess flag={flag}>{evProgDiviNm}</TagProcess>}</>;
};

/** 프로모션 (옐로라이브)
 *  @description useGlobalGoodsFlag() 미리 호출 필요.
 */
const FlagPromotion = (props: {goodsCd: string}) => {
	const {goodsCd} = props;
	if (!goodsCd) return <></>;

	const queryClient = useQueryClient();
	const queryData = queryClient.getQueriesData<Response<GlobalGoodsFlag>>({queryKey: ["useGlobalGoodsFlag"]});
	if (!queryData.length || !queryData[0]?.[1]?.body?.PKG) return <></>;

	const flagData = queryData[0][1].body.PKG;
	if (!flagData) return <></>;

	const flagTypes: string[] = (flagData[goodsCd] && flagData[goodsCd].split(",")) || [];
	const flags = flagTypes.reduce<TypeFlag[]>((acc, cur) => {
		if (goodsFlag(cur)) acc.push(goodsFlag(cur));
		return acc;
	}, []);
	if (!flags.length) return <></>;

	return (
		<>
			{flags.map((item, index) => (
				<Flag key={item.$flag + index} $type={item.$type} $flag={item.$flag} text={item.text} />
			))}
		</>
	);
};

/** 옐로팡딜 */
const FlagYellowPangdeal = (props: {ypdYn: string}) => {
	const {ypdYn} = props;
	if (ypdYn !== "Y") return <></>;
	return <Flag $type="promotion" $flag="yellowpangdeal" text="옐로팡딜" />;
};

/** 옐로PICK */
const FlagYellowPick = (props: {pickYn: string}) => {
	const {pickYn} = props;
	if (pickYn !== "Y") return <></>;
	return <Flag $type="promotion" $flag="yellowpick" text="옐로PICK" />;
};

export {
	FlagEmpasisCd,
	FlagEvProgDivi,
	FlagGoodsBrandCd,
	FlagGoodsCd,
	FlagGoodsTmember,
	FlagGoodsTp,
	FlagPromotion,
	FlagYellowPangdeal,
	FlagYellowPick,
};
